import { createSelector } from 'reselect';

import { getCountries } from 'modules/countries/selectors';
import { getGroupByIds } from 'modules/groups/selectors';
import { getDealerDefaultLanguage } from 'selectors/dealerSelectors';
import { getRoot } from 'utils/selectors';

/**
 * @param {any} state
 * @returns {import('modules/dealers/reducer/ui/modalSelect').State}
 */
const getState = state => state.dealers.ui.modalSelect;

export const isVisible = createSelector(getState, state => state.isVisible);

export const getDealerIds = createSelector(getState, state => state.ids);

export const getPage = createSelector(getState, state => state.page);

const getSort = createSelector(getState, state => state.sort);

export const getFilters = createSelector(getState, state => state.filters);

export const isLoading = createSelector(getState, state => state.isLoading);

export const getParams = createSelector(
  getFilters,
  getPage,
  getSort,
  getDealerDefaultLanguage,
  (filters, { size }, sort, language) => ({
    ...filters,
    sort,
    size,
    language,
  })
);

export const isUnfoldedSearch = createSelector(getState, state => state.expandedSearch);

const getFormattedCountries = createSelector(getFilters, getCountries, (filters, countries) => {
  const field = 'countryCodes';

  return (
    filters[field]?.reduce(
      (acc, code) => ({
        ...acc,
        values: [...acc.values, { value: code, name: countries[code].name }],
      }),
      {
        id: field,
        name: 'Country',
        values: [],
      }
    ) ?? {}
  );
});

const getFilteredGroupId = createSelector(getFilters, filters => filters.groupIds);

const getFilterGroup = createSelector(getRoot, getFilteredGroupId, getGroupByIds);

const getFormattedGroups = createSelector(getFilterGroup, groups => ({
  id: 'groupIds',
  name: 'Groups',
  values: groups.map(({ id: value, name }) => ({ value, name })),
}));

export const getFormattedFilters = createSelector(getFormattedCountries, getFormattedGroups, (countries, groups) => {
  const haveCountries = Object.keys(countries).length > 0;
  const haveGroups = Object.keys(groups).length > 0;

  return [...(haveCountries ? [countries] : []), ...(haveGroups ? [groups] : [])];
});
